module.exports = __webpack_public_path__ + "img/primero.35d36815.png";